// src/lib/ai.js: rol herkennen op basis van een vrije omschrijving.
//
// De prompts worden server-side gebouwd (supabase/functions/ai/prompts.ts);
// hier sturen we alleen de taak + korte velden en parsen we het JSON-antwoord.

import { claude } from "./ai-adapter";

const isAbort = (e) => e?.name === "AbortError";

export const aiHelp = {
  async suggestRol(omschrijving, isFestival, opts) {
    try {
      const text = await claude.call("suggestRol", { omschrijving, isFestival }, opts);
      const jsonMatch = text.match(/\{[\s\S]*\}/);
      if (!jsonMatch) return null;
      return JSON.parse(jsonMatch[0]);
    } catch (e) {
      if (isAbort(e)) return null;
      console.error("AI suggestRol failed", e);
      return null;
    }
  },
};
